import * as StoreUtil from '../util/InClientStoreUtil';
import InstallAppRequest from 'owa-service/lib/contract/InstallAppRequest';
import InstallExtensionJsonRequest from 'owa-service/lib/contract/InstallExtensionJsonRequest';
import installExtensionJsonRequestFactory from 'owa-service/lib/factory/installExtensionJsonRequest';
import InstallExtensionJsonResponse from 'owa-service/lib/contract/InstallExtensionJsonResponse';
import installExtensionOperation from 'owa-service/lib/operation/installExtensionOperation';
import { createOverrideOptions } from '../util/InClientStoreHelper';
import { getClientVersion } from 'owa-config';
import { getJsonRequestHeader } from 'owa-service/lib/ServiceRequestUtils';
import ServiceEndpoint = OSF.ServiceEndpoint;

export function registerMethod(serviceEndPoint: ServiceEndpoint) {
    serviceEndPoint.registerMethod(
        'InstallOutlookWebExtByManifest',
        (data: any, responseMethod: Function) => {
            InstallOutlookWebExtByManifest(data).then(response => {
                if (response.Body.ResponseClass.toString() == 'Error') {
                    responseMethod(
                        [
                            response.Body.MessageText.toString(),
                            response.Body.ResponseCode.toString(),
                        ],
                        -1
                    );
                } else {
                    responseMethod(
                        [
                            !!response.Body.WasFirstInstall,
                            response.Body.Extension ? response.Body.Extension.Id : null,
                            response.Body.Extension
                                ? response.Body.Extension.Enabled.toString()
                                : 'false',
                            response.Body.Extension
                                ? response.Body.Extension.ConsentState.toString()
                                : null,
                            response.Body.Extension
                                ? response.Body.Extension.TypeString.toString()
                                : null,
                            response.Body.Extension
                                ? response.Body.Extension.LicenseStatus.toString()
                                : null,
                            response.Body.Extension
                                ? response.Body.Extension.TrialExpirationDate
                                : null,
                            response.Body.Extension ? response.Body.Extension.Description : null,
                            response.Body.Extension ? response.Body.Extension.ProviderName : null,
                            response.Body.Extension ? response.Body.Extension.IconUrl : null,
                            response.Body.Extension
                                ? response.Body.Extension.HighResolutionIconUrl
                                : null,
                            response.Body.Extension ? response.Body.Extension.DisplayName : null,
                            response.Body.Extension
                                ? response.Body.Extension.Requirements.toString()
                                : null,
                            response.Body.Extension ? response.Body.Extension.Version : null,
                        ],
                        0
                    );
                    StoreUtil.updateAddinSurface();
                }
            });
        },
        Microsoft.Office.Common.InvokeType.async,
        false /* isBlocking */
    );
}

function InstallOutlookWebExtByManifest(data: any): Promise<InstallExtensionJsonResponse> {
    const Body: InstallAppRequest = {
        __type: 'InstallAppRequest:#Exchange',
        MarketplaceAssetId: null,
        MarketplaceContentMarket: null,
        Client: 'WAC_Outlook',
        ClientVersion: getClientVersion(),
        SendWelcomeEmail: true,
        ManifestUrl: null,
        Manifest: data[0],
        Id: null,
    };

    Body.Manifest = StoreUtil.getBase64Encoded(Body.Manifest);
    const installRequest: InstallExtensionJsonRequest = {
        Header: getJsonRequestHeader(StoreUtil.getUserTimeZone()),
        Body: Body,
    };

    const params: InstallExtensionJsonRequest = installExtensionJsonRequestFactory(installRequest);
    const fetchOptions = createOverrideOptions();

    return installExtensionOperation(params, fetchOptions);
}
